module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"missingSearchQueries":"Two queries are required to compute intersection"}}')
  delete Component.options._Ctor
}
